import {Component, OnInit} from '@angular/core';
import {DialogComponent, DialogService} from 'ng2-bootstrap-modal';

export interface Model {
    title: string;
    data: any;
}

@Component({
    selector: 'app-zoom-errors',
    templateUrl: './errors.component.html',
    styleUrls: ['./errors.component.css', '../../myreports.component.css']
})
export class ZoomErrorsComponent extends DialogComponent<Model, any> implements OnInit {

    title: string;
    data: any;
    errors: any = [];
    count = 0;
    selectedError: any;
    isLicense = false;

    constructor(dialogService: DialogService) {
        super(dialogService);
    }

    ngOnInit() {
        this.errors = this.data.errors;
        this.isLicense = this.data.isLicense;
        this.count = this.errors.length;
        document.getElementsByTagName('body')[0].classList.add('modal-open');
    }

    changeSelectedError(error) {
        if (this.selectedError === error) {
            this.selectedError = undefined;
        } else {
            this.selectedError = error;
        }
    }

}



// WEBPACK FOOTER //
// C:/Work/Projects/OnlineParser/web2-ui/src/app/reports/myReports/zoomView/errors/errors.component.ts